// 养老接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 直播线索管理-列表
export const getLiveClueList = (params) => {
  return post(baseApi + '/clue/getClues', params);
}
// 直播线索管理-筛选选项
export const getLiveClueOptions = (params) => {
  return get(baseApi + '/clue/getCluesSearchItems', params);
}
// 直播线索管理-互动状态修改
export const liveClueStatusUpdate = (params) => {
  return post(baseApi + "/clue/updateClueStatus", params);
}
// 直播线索管理-主播排期模板下载
export const liveClueDownSchduleTemplate = (params) => {
  return get(baseApi + "/clue/exportWorkTimeMetal", params, {responseType: "blob"});
}
// 直播线索管理-数据导出
export const liveClueExport = (params) => {
  return post(baseApi + "/clue/downloadClues", params, {
    responseType: "blob",
  });
}
export const exportClues = (params) => {
  return post(baseApi + "/user_clue/exportClues", params, {
    responseType: "blob",
  });
}
// 直播线索管理-上传主播排期表
export const liveClueAnchorSchdueUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(baseApi + "/clue/importWorkTime", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}



// 供数计划 - 列表
export const getSupplyPlanList = (params) => {
  return post(baseApi + '/yanglao/supplyPlan/list', params);
}
// 供数计划 - 机构选项
export const getSupplyPlanOrgOptions = (params) => {
  return get(baseApi + '/yanglao/supplyPlan/mechanismList', params);
}
// 供数计划 - 新增、修改
export const supplyPlanAddOrUpdate = (params) => {
  return post(baseApi + "/yanglao/supplyPlan/saveOrUpdate", params);
}



// 泰康出单概率报表 - 列表
export const getTkOrderReportList = (params) => {
  return post(baseApi + '/tkOrder/yl/tkOrderReport', params);
}


// 直播反馈 - 列表
export const getLiveFeedbackList = (params) => {
  return get(baseApi + '/yangLaoCallback/callback', params);
}
// 直播反馈 - 新增查询
export const liveFeedbackQueryAppointment = (params) => {
  return get(baseApi + '/yangLaoCallback/appointment', params);
}
// 直播反馈 - 新增、修改
export const liveFeedbackAddOrUpdate = (params) => {
  return post(baseApi + "/yangLaoCallback/callback", params);
}



// 泰康线索用户加急/投诉反馈 - 下发列表
export const getClueIssuedList = (params) => {
  return post(baseApi + '/yanglao_bpo/yl/sendUser', params);
}
// 泰康线索用户加急/投诉反馈 - 发送邮件
export const clueIssuedSendMail = (params) => {
  return post(baseApi + "/yanglao_bpo/yl/sendMail", params);
}



// 素材管理 - 列表
export const getMaterialList = (params) => {
  return post(baseApi + '/ylMaterial/getYlMaterialList', params);
}
// 素材管理 - 新增、修改
export const materialAddOrUpdate = (params) => {
  if (params.id > 0) return post(baseApi + "/ylMaterial/modifyYlMaterial", params);
  return post(baseApi + "/ylMaterial/addYlMaterial", params);
}



// 线索录入-获取月费
export const getClueYlMonthlyFee = (params) => get(`${baseApi}/cluesEnter/ylMonthlyFeeApi`, params);
// 线索录入-获取线索详情
export const getClueDetailFromPhone = (params) => get(`${baseApi}/cluesEnter/save`, params);
// 线索录入-单条新增
export const addClueEnter = (params) => post(`${baseApi}/cluesEnter/save`, params);
// 线索录入-上传批量添加模板
export const uploadBatchAddClueTemplate = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(baseApi + "/cluesEnter/analysis", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
// 线索录入-批量新增
export const batchAddClueEnter = (params) => get(`${baseApi}/cluesEnter/batchSave`, params);




// 小蓝表 - 列表
export const getClueMonitorList = (params) => {
  return post(baseApi + '/user_clue/getClue', params);
}
// 小蓝表 - 渠道类型选项
export const getClueMonitorChannelTypeOptions = (params) => {
  return get(baseApi + '/user_clue/getChannelType', params);
}
// 小蓝表 - 数据导出
export const clueMonitorExport = (params) => {
  return post(baseApi + "/user_clue/exportClues", params, {
    responseType: "blob",
  });
}
// 小蓝表 - 获取录音地址
export const getClueMonitorAudioSrc = (params) => {
  return get(baseApi + '/user_clue/getCallInfo', params);
}


// 预算管理 - 列表
export const getBudgetList = (params) => post(baseApi + '/yl/monthPlan/list', params);
// 预算管理 - 新增、修改
export const budgetAddOrUpdate = (params) => {
  if (params.id > 0) return post(baseApi + "/yl/monthPlan/update", params);
  return post(baseApi + "/yl/monthPlan/add", params);
}
